import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const BlogMenu = () => {
  const location = useLocation();

  // Get the last part of the URL path
  const currentPath = location.pathname.split('/')[2];

  // Function to conditionally apply styles based on the current route
  const getFontSize = (path) => {
    return currentPath === path ? 'text-2xl opacity-100' : 'text-xl opacity-50'; // 2x larger font for active route
  };

  return (
    <div className="mb-10">
      <div className="flex flex-col justify-between md:flex-row md:h-10">
        <Link to={'/blog-haberler/teknik-bilgiler-ve-makaleler'}>
          <h6 className={`h-10 transition-all duration-300 ${getFontSize('teknik-bilgiler-ve-makaleler')}`}>
            Teknik Bilgiler Ve Makaleler
          </h6>
        </Link>
        <Link to={'/blog-haberler/sektorel-haberler'}>
          <h6 className={`h-10 transition-all duration-300 ${getFontSize('sektorel-haberler')}`}>
            Sektörel Haberler
          </h6>
        </Link>
        <Link to={'/blog-haberler/bizden-haberler'}>
          <h6 className={`h-10 transition-all duration-300 ${getFontSize('bizden-haberler')}`}>
            Bizden Haberler
          </h6>
        </Link>
      </div>

      <div className="flex justify-between items-center relative">
        {/* <div className="h-5 w-5 rounded-full bg-green-700 absolute -top-2 left-[calc(53%-1.25rem)] z-50 transition-all duration-500"></div> */}
        <div className="h-px w-full bg-customGray"></div>
      </div>
    </div>
  );
};

export default BlogMenu;
